(function () {
  function init(root) {
    var slides = root.querySelectorAll('[data-we-slide]');
    var nonPersist = root.querySelectorAll('[data-we-slide]:not([data-we-persist])');
    var persistSlides = root.querySelectorAll('[data-we-persist]');
    var persistZone = root.querySelector('[data-we-persist-zone]');
    var screens = root.querySelectorAll('[data-we-screen]');
    if (!slides.length) return;

    function setPhone(idx) {
      screens.forEach(function (s) {
        s.classList.toggle('is-active', Number(s.dataset.index) === idx);
      });
    }

    function setActiveSlide(slide) {
      nonPersist.forEach(function (s) { s.classList.toggle('is-active', s === slide); });
    }

    if (window.matchMedia('(max-width: 1023px)').matches) {
      var tabs = root.querySelectorAll('[data-we-tab]');
      function activateMobile(idx) {
        tabs.forEach(function (t) {
          var on = Number(t.dataset.index) === idx;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        slides.forEach(function (s) {
          s.classList.toggle('is-active', Number(s.dataset.index) === idx);
        });
        setPhone(idx);
      }
      tabs.forEach(function (t) {
        t.addEventListener('click', function () { activateMobile(Number(t.dataset.index)); });
      });
      activateMobile(0);
      return;
    }

    // Non-persist slides: fade in when active (IO-driven)
    if ('IntersectionObserver' in window && nonPersist.length) {
      var io = new IntersectionObserver(function (entries) {
        var best = null;
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            if (!best || e.intersectionRatio > best.intersectionRatio) best = e;
          }
        });
        if (best) {
          setActiveSlide(best.target);
          setPhone(Number(best.target.dataset.index));
        }
      }, {
        root: null,
        rootMargin: '-40% 0px -40% 0px',
        threshold: [0, 0.25, 0.5, 0.75, 1]
      });
      nonPersist.forEach(function (s) { io.observe(s); });
    }

    // Persist slides: reveal sequentially via scroll progress through the zone
    if (persistZone && persistSlides.length) {
      var tipEl = persistZone.querySelector('[data-we-tip]');
      var total = persistSlides.length;
      // Steps include each slide + the tip (if present)
      var steps = total + (tipEl ? 1 : 0);
      var ticking = false;

      function update() {
        ticking = false;
        var rect = persistZone.getBoundingClientRect();
        var vh = window.innerHeight;
        var travel = rect.height - vh;
        if (travel <= 0) return;
        var progress = Math.max(0, Math.min(1, -rect.top / travel));

        var lastRevealed = -1;
        persistSlides.forEach(function (s, i) {
          var threshold = (i + 0.5) / steps;
          if (progress >= threshold) {
            s.classList.add('is-revealed');
            lastRevealed = i;
          } else {
            s.classList.remove('is-revealed');
          }
        });

        if (tipEl) {
          var tipThreshold = (total + 0.5) / steps;
          tipEl.classList.toggle('is-revealed', progress >= tipThreshold);
        }

        if (lastRevealed >= 0) {
          setPhone(Number(persistSlides[lastRevealed].dataset.index));
        }
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      root.__wePersistCleanup = function () {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
      };
      update();
    }

    setPhone(0);
  }

  document.querySelectorAll('[data-wearables]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-wearables]');
    if (r) init(r);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var r = e.target.querySelector('[data-wearables]');
    if (r && r.__wePersistCleanup) r.__wePersistCleanup();
  });
})();
